/* Circuit theme JS */
(function () {
  'use strict';

  /* Mobile menu toggle ---------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      var nav = document.getElementById('MobileNav');
      if (nav) {
        var isOpen = nav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }

    var searchToggle = event.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var search = document.getElementById('HeaderSearch');
      if (search) {
        var searchOpen = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', searchOpen ? 'true' : 'false');
        if (searchOpen) {
          var input = search.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
    }
  });

  /* Quantity inputs -------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-change]');
    if (!button) return;

    var wrapper = button.closest('.quantity-input');
    if (!wrapper) return;

    var input = wrapper.querySelector('input');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var delta = button.getAttribute('data-quantity-change') === 'increase' ? 1 : -1;
    var next = Math.max(parseInt(input.min, 10) || 1, current + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart line quantity updates (cart page) ---------------------------------- */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-line-quantity]');
    if (!input) return;

    var line = input.getAttribute('data-line');
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) return;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });

  /* Product form: variant selection ------------------------------------------ */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsScript = document.querySelector('[data-product-variants]');
    var variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var selects = productForm.querySelectorAll('[data-option-select]');
    var idInput = productForm.querySelector('input[name="id"]');
    var addButton = productForm.querySelector('[data-add-to-cart]');
    var addButtonText = productForm.querySelector('[data-add-to-cart-text]');
    var priceEl = document.querySelector('[data-product-price]');

    function formatMoney(cents) {
      var format = productForm.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function onOptionChange() {
      var selectedOptions = Array.prototype.map.call(selects, function (select) {
        return select.value;
      });

      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });
      });

      if (match) {
        if (idInput) idInput.value = match.id;

        if (priceEl) {
          var html = '<span class="' + (match.compare_at_price > match.price ? 'price__sale' : '') + '">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price > match.price) {
            html += ' <s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }

        if (addButton && addButtonText) {
          if (match.available) {
            addButton.disabled = false;
            addButtonText.textContent = addButtonText.getAttribute('data-label-add');
          } else {
            addButton.disabled = true;
            addButtonText.textContent = addButtonText.getAttribute('data-label-sold-out');
          }
        }

        if (match.featured_image && match.featured_image.src) {
          var mainImage = document.querySelector('[data-main-product-image]');
          if (mainImage) mainImage.src = match.featured_image.src;
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } else if (addButton && addButtonText) {
        addButton.disabled = true;
        addButtonText.textContent = addButtonText.getAttribute('data-label-unavailable');
      }
    }

    Array.prototype.forEach.call(selects, function (select) {
      select.addEventListener('change', onOptionChange);
    });
  }

  /* Product gallery thumbnails ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumbnail]');
    if (!thumb) return;

    var mainImage = document.querySelector('[data-main-product-image]');
    if (mainImage) {
      mainImage.src = thumb.getAttribute('data-image-src');
      mainImage.alt = thumb.getAttribute('data-image-alt') || '';
    }

    var thumbs = document.querySelectorAll('[data-thumbnail]');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* Collection sorting ---------------------------------------------------------- */
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
